import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Owner-branding context for templates.
 *
 * Templates render in two host environments — the dev gallery (no auth,
 * no backend) and the contract editor preview (authenticated). Both
 * provide an owner branding value through `OwnerBrandingProvider`; atoms
 * inside templates (`<OwnerLogo>`) read it through `useOwnerBranding`.
 *
 * The contract render itself stays a pure function of `values` + `mode`;
 * branding is intentionally orthogonal so a future server-side renderer
 * can populate the provider with whatever it pulls from storage without
 * the templates needing to know.
 */
import { createContext, useContext } from 'react';
const OwnerBrandingCtx = createContext(null);
export function OwnerBrandingProvider(props) {
    return (_jsx(OwnerBrandingCtx.Provider, { value: props.value, children: props.children }));
}
export function useOwnerBranding() {
    return useContext(OwnerBrandingCtx);
}
//# sourceMappingURL=branding.js.map